<template>
    <section class="w-100 info-banner">
        <div>
            <h1 class="banner-title">{{title}}</h1>
            <p class="banner-description">{{content}}</p>
        </div>
        <div>
            <button type="button" @click="actionPressed" class="link-btn float-right">
                {{actionText}}<i class="fas fa-angle-right ml-2" v-if="withIcon"></i>
            </button>
        </div>
    </section>
</template>

<script>
export default {
    props: ['content', 'title', 'actionText', 'withIcon'],

    methods: {
        actionPressed() {
            this.$emit('pressed');
        }
    }
};
</script>

<style scoped lang="scss">
.info-banner {
    display: flex;
    flex-direction: column;
    background-color: #00b0fe;
    padding: 15px 25px;
    border-radius: 4px;
    color: #fff;
}
.banner-title {
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.57px;
    line-height: 22px;
}
.banner-description {
    font-family: "Open Sans";
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 20px;
    margin: 0 !important;
}
.link-btn {
    color: #FFFFFF;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    border: none;
    outline: none;
    background-color: transparent;

    .fas {
        color: #fff !important;
    }
}
</style>
